import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { AdminDomainService } from '../../domain/services/admin/admin.domain.service';
import { QuotaDomainService } from '../../domain/services/quota/quota.domain.service';

import { Company } from '../../domain/models/company';
import { User } from '../../domain/models/user';
import { Quota } from '../../domain/models/quota';
import { QuotaDetail } from '../../domain/models/quotaDetails';

import * as _ from 'lodash';
import { QuotaHistory } from 'app/modules/domain/models/quotaHistory';

@Injectable()
export class AdminService {


  constructor(private adminDomainService: AdminDomainService, private quotaDomainService: QuotaDomainService) { }

  getCompanies(): Observable<{} | Company[]> {
    return this.adminDomainService.getCompanies();
  }

  addNewOrganization(company: Company): Observable<{}> {
    return this.adminDomainService.createCompany(company);
  }

  getUsersForCompany(companyId: string): Observable<{} | User[]> {
    return this.adminDomainService.getUsersForCompany(companyId);
  }

  createUser(user: Partial<User>): Observable<{} | boolean> {
    return this.adminDomainService.createUser(user, user.companyId);
  }

  updateUser(user: User): Observable<{} | boolean> {
    return this.adminDomainService.updateUser(user);
  }

  deleteUser(companyId: string, userId: string): Observable<{} | boolean> {
    return this.adminDomainService.deleteUser(companyId, userId);
  }

  getImpersonationToken(userId: string, companyId: string): Observable<{} | any> {
    return this.adminDomainService.getImpersonationToken(userId, companyId);
  }

  getCurrentCompany(companyId: string): Observable<{} | Company> {
    return this.adminDomainService.getCurrentCompany(companyId);
  }

  updateCompany(company: Company): Observable<{} | boolean> {
    return this.adminDomainService.updateCompany(company);
  }

  deleteCompany(companyId: string, deleteToken: string): Observable<{} | boolean> {
    return this.adminDomainService.deleteCompany(companyId, deleteToken);
  }

  getQuotaForCompanies(): Observable<{} | QuotaDetail> {
    return this.quotaDomainService.getQuotaForCompanies();
  }

  getQuotaForCompany(companyId: string): Observable<{} | QuotaDetail> {
    return this.quotaDomainService.getAllQuotasForCompany(companyId);
  }

  setQuotaForCompany(companyId: string, quota: { quota?: number; apiKey?: string }): Observable<{} | boolean> {
    return this.quotaDomainService.setQuotaForCompany(companyId, quota);
  }

  getQuotaForCompanyUsers(companyId: string): Observable<{} | Quota[]> {
    return this.quotaDomainService.getQuotaForCompanyUsers(companyId);
  }

  getOwnQuota(): Observable<QuotaDetail> {
    return this.quotaDomainService.getOwnQuota();
  }

  getQuotaHistory(companyId: string, userId: string, from: string, to: string): Observable<QuotaHistory[]> {
    return this.quotaDomainService.getQuotaHistory(companyId, userId, from, to);
  }

  updateUserQuota(companyId: string, userId: string, quotaLimit: number): Observable<{} | boolean> {
    return this.quotaDomainService.setQuotaForUser(companyId, userId, quotaLimit);
  }

  getCurrentUserInfo(): Observable<{} | User> {
    return this.adminDomainService.getCurrentUserInfo();
  }

  updateUsername(userName: string): Observable<{} | boolean> {
    return this.adminDomainService.updateUsername(userName);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/services/admin.service.ts